import dynamic from 'next/dynamic'

export const DynamicProductHeadBioLabel = dynamic(async () =>
  import('./ProductHeadBioLabel').then((mod) => mod.ProductHeadBioLabel),
)
